( function () {
	'use strict';

	function getRoutes () {
		return [
			{
				'url' : '/report',

				'config' : {
					'templateUrl'  : '/templates/report/report.html',
					'controller'   : 'Report',
					'controllerAs' : 'vm',
					'title'        : 'Reports',
					'state'        : 'reports',
					'access'       : {
						'requiredLogin' : true
					},

					'settings' : {
						'nav'     : 5,
						'content' : '<span class="reports-icon"></span><span class="hidden-xs hidden-sm qa-nav-reports">Reports</span>'
					}
				}
			}, {
				'url' : '/report/observation-by-template',

				'config' : {
					'templateUrl' : '/templates/report/generate-template/generate.html',
					'title'       : 'Generated Report',
					'category'    : 'sub-routes',
					'state'       : 'reports',
					'access'      : {
						'requiredLogin' : true
					}
				}
			}, {
				'url' : '/report/observation-status',

				'config' : {
					'templateUrl' : '/templates/report/generate-status/generate-status.html',
					'title'       : 'Generated Status Report',
					'category'    : 'sub-routes',
					'state'       : 'reports',
					'access'      : {
						'requiredLogin' : true
					}
				}
			}, {
				'url'    : '/report/assignment-status',
				'config' : {
					'templateUrl' : '/templates/report/generate-pd-status/generate-pd-status.html',
					'title'       : 'Generated Assignment Status Report',
					'category'    : 'sub-routes',
					'state'       : 'reports',
					'access'      : {
						'requiredLogin' : true
					}
				}
			}, {
				'url'    : '/report/data-export',
				'config' : {
					'templateUrl' : '/templates/report/generate-data-export/generate-data-export.html',
					'title'       : 'Generated Data Export Report',
					'category'    : 'sub-routes',
					'state'       : 'reports',
					'access'      : {
						'requiredLogin' : true
					}
				}
			}, {
				'url'    : '/report/warehouse-export',
				'config' : {
					'templateUrl'  : '/templates/report/generate-warehouse-export/generate-warehouse-export.html',
					'controller'   : 'GenerateWarehouseExportReport',
					'controllerAs' : 'vm',
					'title'        : 'Observation Data Warehouse Export',
					'category'     : 'sub-routes',
					'state'        : 'reports',
					'access'       : {
						'requiredLogin' : true
					}
				}
			}, {
				'url'    : '/report/request-custom-report',
				'config' : {
					'templateUrl'  : '/templates/report/request-custom-report/request-custom-report-page.html',
					'controller'   : 'RequestCustomReportPageCtrl',
					'controllerAs' : 'vm',
					'title'        : 'Request Custom Report Page',
					'category'     : 'sub-routes',
					'state'        : 'reports',
					'access'       : {
						'requiredLogin' : true
					}
				}
			}, {
				'url'    : '/report/request-custom-report/submitted',
				'config' : {
					'templateUrl' : '/templates/report/request-custom-report/request-custom-report-success.html',
					'title'       : 'Submitted Custom Report Request',
					'category'    : 'sub-routes',
					'state'       : 'reports',
					'access'      : {
						'requiredLogin' : true
					}
				}
			}, {
				'url'    : '/report/proficiency-trend-report-individual',
				'config' : {
					'templateUrl' : '/templates/report/generate-results-by-template/generate-results-by-template.html',
					'title'       : 'Proficiency Trend Report - Individual',
					'category'    : 'sub-routes',
					'state'       : 'reports',
					'access'      : {
						'requiredLogin' : true
					}
				}
			}, {
				'url'    : '/report/component',
				'config' : {
					'templateUrl'  : '/templates/report/report-component-page/report-component-page.html',
					'controller'   : 'reportComponentPage',
					'controllerAs' : 'vm',
					'title'        : 'Reports',
					'category'     : 'sub-routes',
					'state'        : 'reports',
					'access'       : {
						'requiredLogin' : true
					}
				}
			}
		];
	}

	/* @ngInject */
	function appRun ( routehelper ) {
		routehelper.configureRoutes( getRoutes() );
	}

	angular
		.module( 'app.report' )
		.run( appRun );
} )( );
